export function currencyFormatter(currency, sign) {
    if (currency === '' || currency === null || currency === undefined || isNaN(currency)) {
        return `${sign}0.00`;
    }
    const sansDec = `${currency.toFixed(2)}`;
    const formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (currency < 0) {
        return `(${sign}${formatted.replace('-', '')})`;
    }
    return sign + `${formatted}`;
}
